// src/App.jsx
import { useEffect, useState } from "react";
import Routers from "./Routers/Routers";
import { ThemeProvider as CustomThemeProvider } from "./utils/context/ThemeContext";
import { Toaster } from "react-hot-toast";
import { useAuth } from "@clerk/clerk-react";
import { setupInterceptors } from "./utils/axios/axiosConfig";
import { UserProvider } from "./utils/context/UserProvider";
function App() {
  const { isLoaded, getToken, signOut } = useAuth();
  const [interceptorsReady, setInterceptorsReady] = useState(false);

  useEffect(() => {
    if (!isLoaded) return;

    setupInterceptors({
      getToken: () => getToken(),
      logout: () => signOut({ redirectUrl: "/login" }),
    });

    setInterceptorsReady(true);
  }, [isLoaded, getToken, signOut]);

  return (
    <div
      className="bg-neutral-100 dark:border-neutral-900 dark:bg-neutral-900"
      style={{ textAlign: "center", width: "100vw" }}
    >
      <CustomThemeProvider>
        {interceptorsReady ? (
          <UserProvider>
            <Toaster richColors position="top-right" />
            <Routers />
          </UserProvider>
        ) : (
          <div />
        )}
      </CustomThemeProvider>
    </div>
  );
}

export default App;
